const jstOffset = 9 * 60 * 60 * 1000

export const convertDateTimeLocalToEpochMillis = (dateTimeLocal: string): number => {
  const date = new Date(dateTimeLocal)
  return date.getTime()
}

export const convertEpochMillisToDateTimeLocal = (epochMillis: number, isDateOnly: boolean = false): string => {
  const date = new Date(epochMillis)
  const pad = (num: number) => num.toString().padStart(2, "0")
  const year = date.getFullYear()
  const month = pad(date.getMonth() + 1)
  const day = pad(date.getDate())
  const hours = pad(date.getHours())
  const minutes = pad(date.getMinutes())
  const seconds = pad(date.getSeconds())

  return isDateOnly ? `${year}-${month}-${day}` : `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
}

/**
 * @param date で与えられた日付をJSTにおける00:00:00.000のUTCタイムスタンプを持つDateを返す。
 */
export function getJSTStartOfDay(date: Date): Date {
  const jstTime = date.getTime() + jstOffset
  const jstDate = new Date(jstTime)
  const startOfDayInJst = Date.UTC(
    jstDate.getUTCFullYear(),
    jstDate.getUTCMonth(),
    jstDate.getUTCDate()
  )
  return new Date(startOfDayInJst - jstOffset)

}

export function addDays(date: Date, days: number): Date {
  return new Date(date.getTime() + days * 24 * 60 * 60 * 1000)
}

/**
 * 現在時刻から業務日を計算する
 * JST 15:00 を業務日の境界とする
 *
 * 例: JST 2025-11-06 14:59 → 業務日 2025-11-05
 *     JST 2025-11-06 15:00 → 業務日 2025-11-06
 */
export function calculateBusinessDay(now: Date): { dayKey: string; dayStartAt: Date } {
  const businessDayBoundaryHour = 15

  const jstTime = now.getTime() + jstOffset
  const jstDate = new Date(jstTime)

  let businessDate: Date
  if (jstDate.getUTCHours() < businessDayBoundaryHour) {
    businessDate = new Date(Date.UTC(
      jstDate.getUTCFullYear(),
      jstDate.getUTCMonth(),
      jstDate.getUTCDate() - 1
    ))
  } else {
    businessDate = new Date(Date.UTC(
      jstDate.getUTCFullYear(),
      jstDate.getUTCMonth(),
      jstDate.getUTCDate()
    ))
  }

  const year = businessDate.getUTCFullYear()
  const month = String(businessDate.getUTCMonth() + 1).padStart(2, "0")
  const day = String(businessDate.getUTCDate()).padStart(2, "0")
  const dayKey = `${year}-${month}-${day}`

  const dayStartAt = new Date(Date.UTC(
    businessDate.getUTCFullYear(),
    businessDate.getUTCMonth(),
    businessDate.getUTCDate(),
    6, 0, 0, 0
  ))

  return { dayKey, dayStartAt }
}
